import * as THREE from 'three';
import { Canvas, useLoader, useFrame, useThree } from "@react-three/fiber";
import { CameraControls, Center, Environment, Html, useProgress } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Suspense, useCallback, useEffect, useRef, useState } from 'react';
import cssStyles from './threed-modal.module.scss';
import { Leva, button, buttonGroup, folder, useControls } from 'leva';
import { RGBELoader } from 'three-stdlib';
import { BrightnessContrast, HueSaturation, EffectComposer, ToneMapping, SMAA } from '@react-three/postprocessing';
import axios from 'axios';
import recorder from "react-canvas-recorder";


const JSZip = require("jszip-sync");



interface ThreedModalData {
  glbModel: string,
  showCaptureButtons?: boolean;
  height?: string;
  disableButton?: boolean;
  sceneBackground?: string;
  controls?: boolean;
  postControlHandler?: any;
  productControls?: any;
  skuId?: string;
  mode?: string;
}

interface ThreedData {
  skuId: string | undefined;
  controls?: boolean;
  vendorIdName?: string;
  height?: string;
  showCaptureBtn?: boolean;
  disableButton?: boolean;
  mode?: string;
}


const firstTimeLoad = {
  set: true
};

const sceneBackgroundList =
{
  'None': '',
  'Play Canvas': '/hdr/Playcanvas4k.hdr',
  "HDR 1": "/hdr/Soft-1Front-2Backs.hdr",
  "HDR 2": "/hdr/Soft-1Front.hdr",
  "HDR 3": "/hdr/Soft-1LowContrast-Front.hdr",
  "HDR 4": "/hdr/Soft-1LowContrastFront-2Backs.hdr",
  "HDR 5": "/hdr/Soft-2RingHighContrast.hdr",
  "HDR 6": "/hdr/Soft-2RingLowContrast.hdr",
  "HDR 7": "/hdr/Soft-4TubeBank-2BlackFlags.hdr",
  "HDR 8": "/hdr/Soft-5DaylightStudio.hdr",
  "Brown Photo Studio": "/hdr/brown_photostudio_02_4k.hdr",
  "Christmas Photo Studio": "/hdr/christmas_photo_studio_06_4k.hdr",
  "Cyclorama Hard Light": "/hdr/cyclorama_hard_light_4k.hdr",
  "Photo Studio": "/hdr/photo_studio_01_4k.hdr",
  "Studio Lighting 1": "/hdr/studio_small_03_4k.hdr",
  "Studio Lighting 2": "/hdr/studio_small_09_4k.hdr",
  "Panorama": "/hdr/Panorama.hdr"
}

const envToneMaping = {
  'None': THREE.NoToneMapping,
  'Linear': THREE.LinearToneMapping,
  'Reinhard': THREE.ReinhardToneMapping,
  'Cineon': THREE.CineonToneMapping,
  'ACESFilmic': THREE.ACESFilmicToneMapping
}

function Loader() {
  return <Html center>Loading...</Html>
}

const ThreeD: React.FC<ThreedData> = ({ skuId, controls = false, vendorIdName = '', height = '100vh', showCaptureBtn = false, mode="nonpdp" }) => {
  const [glbPath, setGlbPath] = useState('');
  const apiBaseUrl = 'https://d221a61rb87vel.cloudfront.net/v1/api/product3DView';
  const [productControls, setProductControls] = useState(null);
  const [showLoader, setShowLoader] = useState(true);
  const [previewImages, setPreviewImages] = useState<string[]>([]);
  const [previewIndex, setPreviewIndex] = useState(-1);
 

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const vendorId = vendorIdName !== '' ? vendorIdName : (searchParams.get('vendorId') ? searchParams.get('vendorId') : 'NewVendor');
    const url = apiBaseUrl + "?vendorId=" + vendorId + (skuId !== '' ? '&productSkuID=' + skuId : '');
    //const previewImageArr: string[] = [];
    axios.get(url)
      .then(response => {
        if (response.data && response.data.length > 0) {
          setGlbPath(response.data[0].nestGlb3D)
          if (response.data[0].controls) {
            setProductControls(response.data[0].controls);
            // fetch(response.data[0].filmStripImagesZip)
            //   .then(response => response.arrayBuffer())
            //   .then(data => JSZip.loadAsync(data))
            //   .then(zip => {
            //     // Filter the files to only include image files
            //     const imageFiles = Object.keys(zip.files)
            //       .filter(filename => /\.(jpe?g|png|gif)$/i.test(filename));

            //     // Download each image file
            //     imageFiles.forEach((filename, index) => {
            //       zip.file(filename)
            //         .async('blob')
            //         .then((blob: any) => {
            //           previewImageArr.push(URL.createObjectURL(blob))
            //           if (imageFiles.length === (index + 1)) {
            //             setPreviewImages(previewImageArr);
            //           }

            //         });
            //     });

            //   })
            //   .catch(error => console.error(error));

          }
          setShowLoader(false);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, [setGlbPath, glbPath]);

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const vendorId = vendorIdName !== '' ? vendorIdName : (searchParams.get('vendorId') ? searchParams.get('vendorId') : 'NewVendor');
    const url = apiBaseUrl + "?vendorId=" + vendorId + (skuId !== '' ? '&productSkuID=' + skuId : '');
    const previewImageArr: string[] = [];
    const fetchData = async () => {
      await axios.get(url)
        .then(response => {
          if (response.data && response.data.length > 0) {
            fetch(response.data[0].filmStripImagesZip)
              .then(response => response.arrayBuffer())
              .then(data => JSZip.loadAsync(data))
              .then(zip => {
                // Filter the files to only include image files
                const imageFiles = Object.keys(zip.files)
                  .filter(filename => /\.(jpe?g|png|gif)$/i.test(filename));

                // Download each image file
                imageFiles.forEach((filename, index) => {
                  zip.file(filename)
                    .async('blob')
                    .then((blob: any) => {
                      previewImageArr.push(URL.createObjectURL(blob))
                      if (imageFiles.length === (index + 1)) {
                        setPreviewImages(previewImageArr);
                        //return previewImageArr
                      }

                    });
                });

              })
              .catch(error => console.error(error));
          }
        })
        .catch(error => {
          console.error(error);
        });
      //setPreviewImages(result) // set your state hook
    };

    fetchData() // run the async fn
  }, [])

  const postControlHandler = useCallback((controls: any) => {
    const searchParams = new URLSearchParams(document.location.search);
    const vendorId = searchParams.get('vendorId') ? searchParams.get('vendorId') : 'NewVendor';
    const postData = {
      "productSkuID": skuId,
      "vendorId": vendorId,
      "controls": controls
    }
    const headers = {
      accept: 'application/json',
    }
    axios.post(apiBaseUrl + '/update', postData, headers as any)
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const previewProduct = useCallback((index: any) => {
    setPreviewIndex(index);
    firstTimeLoad.set = true;
  }, [])


  return (
    <div style={{ 'width': '100%', 'height': height }} className={previewImages?.length > 0 ? cssStyles.has_preview : ''}>
      {showLoader && <div className={cssStyles.loader}>Loading...</div>}
      
      {previewImages?.length > 0 && mode === 'nonpdp' && <ul className={cssStyles.threed_preview_images}>
        {
          previewImages?.map((preview, index) => {
            return <li key={'preview' + index} onClick={() => previewProduct(index)}><img src={preview} /></li>
          })
        }
      </ul>}
      {previewIndex > -1 && mode === 'nonpdp' && <div className={cssStyles.btn_container}><button className={cssStyles.recording_btn} onClick={() => previewProduct(-1)}>Show 3D</button></div>}
      {previewIndex > -1 && mode === 'nonpdp' && <div className={cssStyles.preview_section}>
        <img src={previewImages[previewIndex]} />
      </div>}
      {glbPath && previewIndex === -1 && <ThreeDModal mode={mode} skuId={skuId} glbModel={glbPath} showCaptureButtons={showCaptureBtn} height={height} postControlHandler={postControlHandler} productControls={productControls} controls={controls} />}
    </div>
  )
}

const ThreeDModal: React.FC<ThreedModalData> = ({ mode, skuId, glbModel, showCaptureButtons = false, height, disableButton = false, sceneBackground = '', controls, postControlHandler, productControls = null }) => {
  const [glbPath, setGlbPath] = useState(glbModel);
  const { scene } = useLoader(GLTFLoader, glbPath);
  const meshRef = useRef<THREE.Mesh>(null!);
 
  const cameraControlsRef = useRef<CameraControls>(null!);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const apiBaseUrl = 'https://d221a61rb87vel.cloudfront.net/v1/api/product3DView';
  const [zipSignedUrl, setZipSignedUrl] = useState('');
  const zip = new JSZip();
  const [screenCaptureLoader, setScreenCaptureLoader] = useState(false);

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const vendorId = searchParams.get('vendorId') ? searchParams.get('vendorId') : 'NewVendor';
    const url = apiBaseUrl + "/updateFilmStripImages";
    const headers = {
      accept: 'application/json',
    }
    const postData = {
      "productSkuID": skuId,
      "vendorId": vendorId,
    }
    axios.post(url, postData, headers as any)
      .then(function (response) {
        setZipSignedUrl(response.data.zipSignedUrl);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  const controlsData: any = useControls({
    autoRotate: {
      label: 'Rotate',
      value: false
    },
    bg: { value: productControls && productControls.bg || '#fff', label: 'Background' },
    'Environment': folder({
      showEnv: { value: (productControls && productControls.showEnv) ? productControls.showEnv : false, label: 'Enable' },
      showEnvBg: { label: 'Enable Bg', value: (productControls && productControls.showEnvBg) ? productControls.showEnvBg : false },
      envFile: { value: productControls && productControls.envFile ? productControls.envFile : '', label: 'Environment', options: sceneBackgroundList },
    }, { collapsed: true }),
    'Tone Mapping': folder({
      exposure: { value: productControls && productControls.exposure || 1, min: 0, max: 6, step: 0.01 },
      toneMapping: { value: productControls && productControls.toneMapping || THREE.NoToneMapping, options: envToneMaping }
    }, { collapsed: true }),
    'Ambient Light': folder({
      ambientVisible: { label: 'Visible', value: productControls && productControls.ambientVisible || false },
      ambientIntensity: { label: 'Intensity', value: productControls && productControls.ambientIntensity || 2, min: 0, max: 10, step: 0.01 },
      ambientColor: { label: 'Color', value: productControls && productControls.ambientColor || '#bebebe' },
    }, { collapsed: true }),
    'Directional Light': folder({
      directionalVisible: { label: 'Visible', value: productControls && productControls.directionalVisible || false },
      directionalPosition: { value: productControls && productControls.directionalPosition || [0, 1, 1] },
      directionalIntensity: { label: 'Intensity', value: productControls && productControls.directionalIntensity || 2, min: 0, max: 10, step: 0.01 },
      directionalColor: { label: 'Color', value: productControls && productControls.directionalColor || '#bebebe' },
    }, { collapsed: true }),
    'Point Light': folder({
      pointVisible: { label: 'Visible', value: productControls && productControls.pointVisible || false },
      pointPosition: { value: productControls && productControls.pointPosition || [2, 0, 0] },
      pointIntensity: { label: 'Intensity', value: productControls && productControls.pointIntensity || 2, min: 0, max: 10, step: 0.01 },
      pointColor: { label: 'Color', value: productControls && productControls.pointColor || '#bebebe' },
    }, { collapsed: true }),
    'Spot Light': folder({
      spotVisible: { label: 'Visible', value: productControls && productControls.spotVisible || false },
      spotPosition: { value: productControls && productControls.spotPosition || [3, 2.5, 1] },
      spotIntensity: { label: 'Intensity', value: productControls && productControls.spotIntensity || 2, min: 0, max: 10, step: 0.01 },
      spotColor: { label: 'Color', value: productControls && productControls.spotColor || '#bebebe' },
    }, { collapsed: true }),
    'All Effects': folder({
      enableEffect: { value: productControls && productControls.enableEffect || false },
      brightness: { value: productControls && productControls.brightness || 0, min: -1, max: 1, step: 0.01 },
      contrast: { value: productControls && productControls.contrast || 0, min: -1, max: 1, step: 0.01 },
      hue: { value: productControls && productControls.hue || 0, min: 0, max: 1, step: 0.01, },
      saturation: { value: productControls && productControls.saturation || 0, min: 0, max: 5, step: 0.01 },
      middleGrey: { value: productControls && productControls.middleGrey || 0.6, min: 0, max: 1, step: 0.01 },
      maxLuminance: { value: productControls && productControls.maxLuminance || 16.0, min: 0, max: 64, step: 0.01 }
    }, { collapsed: true })
  }, { collapsed: true })

  const postControlData = () => {
    if (controlsData) {
      postControlHandler(controlsData);
    }
  }

  if (firstTimeLoad.set && cameraControlsRef.current) {

    const options = {
      paddingTop: 0.2,
      paddingRight: 0.2,
      paddingBottom: 0.2,
      paddingLeft: 0.2
    }
    //cameraControlsRef.current?.reset(true);
    cameraControlsRef.current?.fitToBox(meshRef.current, true, options);
    //cameraControlsRef.current?.fitToSphere(meshRef.current, true);
    firstTimeLoad.set = false;
  }

  const uploadFile = useCallback((event: any) => {
    const file: any = event.target.files[0];
    var reader = new FileReader();
    reader.onload = function (event: any) {
      setGlbPath(event.target.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  }, [setGlbPath])


  const ProductMesh = (): JSX.Element => {
  
    useFrame((_, delta) => {
      if (controlsData.autoRotate) {
        meshRef.current.rotation.y += 0.4 * delta;
      }
    });

    return (
      <mesh ref={meshRef}>
        <primitive object={scene} dispose={null} />
      </mesh>
    )
  }
  const startRecording = useCallback(() => {
    if (canvasRef.current) {
      recorder.createStream(canvasRef.current);
      recorder.start();
    }
  }, [canvasRef]);

  const stopRecording = useCallback(() => {
    recorder.stop();
    const file = recorder.save();
    const csvURL = window.URL.createObjectURL(file);
    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', skuId + '.mp4');
    tempLink.click();
  }, []);

  let i = 0;

  const captureAllSides = useCallback((zipUrl: any) => {
    setTimeout(function () {
      if (cameraControlsRef.current && canvasRef.current) {
        cameraControlsRef.current.rotate(45 * THREE.MathUtils.DEG2RAD, 0, true);
        const screenShot = canvasRef.current.toDataURL();
        const zipped = zip.sync(function () {
          // put some stuff in there
          zip.file(i + "canvas.jpeg", screenShot.split('base64,')[1], { base64: true });
          // call regular async methods
          var data = null;
          zip.generateAsync({ type: "blob", compression: "DEFLATE" })
            .then(function (content: any) {
              data = content;
            });
          return data;
        });
        if (i === 7) {
          postScreenCaptures(zipped, zipUrl);
          //console.log("screen array", screenShotArray);
          // const link = document.createElement("a");
          // link.href = window.URL.createObjectURL(zipped);
          // link.download = "snapcial.zip";
          // link.click();
        }
      }
      i++;
      if (i < 8) {
        captureAllSides(zipUrl);
      }
    }, 500)
  }, [])

  const postScreenCaptures = useCallback((imageZip: any, zipUrl: any) => {
    if (zipUrl !== '') {
      axios.put(zipUrl, imageZip, {
        headers: {
          "Content-Type": "application/zip",
        },
      })
        .then(function (response) {
          setScreenCaptureLoader(false)
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
          setScreenCaptureLoader(false)
        });
    }
  }, [])

  const handleCaptureAllSides = useCallback(() => {
    
    i = 0;
    captureAllSides(zipSignedUrl);
    setScreenCaptureLoader(true)
  }, [zipSignedUrl, setZipSignedUrl])

  type CustomEnvironmentProps = {
    url: string
    backupPreset?: 'sunset' | 'city' | 'park' | 'warehouse' | 'dawn' | 'night' | 'forest'
    background?: boolean
  }

  // Create a custom environment component that handles failures your way
  function StableEnvironment({ url, background }: CustomEnvironmentProps) {
    const { scene } = useThree()
    const [status, setStatus] = useState('loading')

    //const urlJpg = url.replace(".hdr", ".jpg")

    useEffect(() => {
      // First, try loading the .hdr file
      const hdrLoader = new RGBELoader();
      
      hdrLoader.load(
        url, // Assume url points to .hdr (e.g., example.hdr)
        (texture) => {
          texture.mapping = THREE.EquirectangularReflectionMapping;
          scene.environment = texture;
          if (background) scene.background = texture;
          setStatus('loaded');
        },
        undefined,
        (error) => {
          console.warn('HDR load failed:', error);
          // If HDR fails, try loading the .jpg file
          const jpgUrl = url.replace(/\.hdr$/i, '.jpg');
          const jpgLoader = new THREE.TextureLoader();

          jpgLoader.load(
            jpgUrl,
            (texture) => {
              texture.mapping = THREE.EquirectangularReflectionMapping;
              scene.environment = texture;
              if (background) scene.background = texture;
              setStatus('loaded');
            },
            undefined,
            (jpgError) => {
              console.error('JPG load failed:', jpgError);
              setStatus('error');
            }
          );
        }
      );

      // Cleanup on unmount or when url/background changes
      return () => {
        scene.environment = null;
        if (background) scene.background = null;
      };
    }, [url, background]);

    if (status === 'error') {
      return <Environment preset="lobby" background={background} />
    }

    return null
  }


  return (
    <>
      {mode === 'nonpdp' && <div className={cssStyles.btn_container}>
        {showCaptureButtons && (
          <>
            <button className={`${cssStyles.recording_btn} ${disableButton ? cssStyles.disabled : ''}`} onClick={() => startRecording()}>Start Recording</button>
            <button className={`${cssStyles.recording_btn}  ${disableButton ? cssStyles.disabled : ''}`} onClick={() => stopRecording()}>Stop Recording</button>
          </>
        )}
        <button className={`${cssStyles.recording_btn} ${cssStyles.disabled} ${cssStyles.life_style}`}>Lifestyle View</button>
        <button className={cssStyles.recording_btn} onClick={() => handleCaptureAllSides()}>Capture Screenshot</button>
      </div>
      }
      {screenCaptureLoader && mode === 'nonpdp' && <div className={cssStyles.capture_loader}>Capturing...</div>}

      {controls && <div className={cssStyles.button_section}>
        <button className={cssStyles.glb_uploader}>Preview Own GLB <input type="file" onChange={uploadFile} /></button>
        <button className={cssStyles.save} onClick={postControlData}>Save State</button>
      </div>}
      
      <div className={`${cssStyles.preview_container} ${mode === 'nonpdp' ? cssStyles.preview_container_nonpdp : ''}`} style={{ backgroundColor: controlsData.bg, height: height}}>
        <span className={cssStyles.leva_controller}><Leva hidden={!controls} collapsed /></span>
        <Canvas style={{ backgroundColor: controlsData.bg }} gl={{ preserveDrawingBuffer: true, toneMappingExposure: controlsData.exposure, toneMapping: controlsData.toneMapping }} camera={{ fov: 50, position: [0, 0, 5] }} ref={canvasRef}>
        <Suspense fallback={<Loader />}>
          <color attach="background" args={[controlsData.bg]} />
          <group position-y={-0.5}>
            <Center top>
              <ProductMesh />
            </Center>
            <ambientLight visible={controlsData.ambientVisible} intensity={controlsData.ambientIntensity} color={controlsData.ambientColor} />
            <directionalLight visible={controlsData.directionalVisible} position={controlsData.directionalPosition} intensity={controlsData.directionalIntensity} color={controlsData.directionalColor} />
            <pointLight visible={controlsData.pointVisible} position={controlsData.pointPosition} intensity={controlsData.pointIntensity} color={controlsData.pointColor} />
            <spotLight visible={controlsData.spotVisible} position={controlsData.spotPosition} intensity={controlsData.spotIntensity} color={controlsData.spotColor} />
            <EffectComposer enabled={controlsData.enableEffect} multisampling={0}>
              <SMAA />
              <BrightnessContrast brightness={controlsData.brightness} contrast={controlsData.contrast} />
              <HueSaturation hue={controlsData.hue} saturation={controlsData.saturation} />
              <ToneMapping middleGrey={controlsData.middleGrey} maxLuminance={controlsData.maxLuminance} />
            </EffectComposer>
          </group>
          <CameraControls
            ref={cameraControlsRef}
            enabled={true}
            verticalDragToForward={false}
            dollyToCursor={false}
            infinityDolly={false}
            maxPolarAngle={Math.PI * 0.5}
          />

          {controlsData.showEnv && controlsData.envFile && (
            <StableEnvironment 
              url={`https://d221a61rb87vel.cloudfront.net/catalog-assets${controlsData.envFile}`}
              background={controlsData.showEnvBg}
            />
          )}

        </Suspense>
        </Canvas>
      
      </div>
    </>

  )
}

export default ThreeD